<template>
  <div>
    <h1 class="text-center q-pt-xl text-bold">
      404
    </h1>
    <h2 class="text-center q-py-5">
      Sorry, nothing here...
    </h2>
    <div class="text-center">
      <q-btn
        color="red"
        @click="$router.push('/')"
      >
        Go back
      </q-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Error404'
};
</script>
